import { createReducer, on } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { DateTime } from 'luxon';

import { Counters, DashCounters } from '@apps/auth/domain/models/back/dash-counters';
import { BackAuthCountersLoaded } from '@apps/back/store/auth/auth.actions';
import { Entity } from '@apps/auth/domain/models/back';
import { BackConstants, InternalStatus } from '@apps/back/back.constants';

import { IEntitiesState, entitiesInitialState, entitiesAdapter } from '../entities.common';
import { ODataAuth } from '../../ODataAuth';
import * as fromBackAuthEntitiesInternal from './entities-internal.actions';

export const BackAuthEntitiesInternalFeatureKey = 'internal';

export interface IBackAuthEntitiesInternalState
{
    counters: Counters;
    oData: ODataAuth;
    entities: IEntitiesState;
    isEmpty: boolean;
    isLoading: boolean;
    isLoaded: boolean;
    isOups: boolean;
    qsWord: string;
    qsWordImpe: string;
    expirationDate: DateTime;
}

export const BackAuthEntitiesInternalInitialState: IBackAuthEntitiesInternalState =
{
    counters: new Counters(),
    oData: new ODataAuth(BackConstants.QSEntitiesTop, InternalStatus),
    entities: entitiesInitialState,
    isEmpty: false,
    isLoading: false,
    isLoaded: false,
    isOups: false,
    qsWord: '',
    qsWordImpe: '',
    expirationDate: null
};

export const BackAuthEntitiesInternalReducer = createReducer(
    BackAuthEntitiesInternalInitialState,
    on(
        BackAuthCountersLoaded,
        (state: IBackAuthEntitiesInternalState, { entitiesCounters }: { entitiesCounters: DashCounters, usersCounters: DashCounters }) => ({
            ...state,
            counters: entitiesCounters.internal
        })
    ),
    on(
        fromBackAuthEntitiesInternal.BackAuthEntitiesInternalODataRequested,
        (state: IBackAuthEntitiesInternalState) =>
            ({
                ...state,
                isLoading: !(state.expirationDate !== null && DateTime.utc() < state.expirationDate)
            }),
    ),
    on(
        fromBackAuthEntitiesInternal.BackAuthEntitiesInternalODataLoaded,
        (state: IBackAuthEntitiesInternalState, { entities }: {entities: Entity[]}) =>
            ({
                ...state,
                isLoading: false,
                isOups: false,
                isLoaded: entities && entities.length !== 0,
                entities: entitiesAdapter.setAll(entities, state.entities),
                expirationDate: DateTime.utc().plus({ minutes: BackConstants.DataLifeTime })
            })
    ),
    on(
        fromBackAuthEntitiesInternal.BackAuthEntitiesInternalQsWordSet,
        (state, { qsWord }: { qsWord: string; }) =>
            ({
                ...state,
                qsWord: qsWord.toLowerCase()
            })
    ),
    on(
        fromBackAuthEntitiesInternal.BackAuthEntityInternalUpdated,
        (state: IBackAuthEntitiesInternalState, { entity }: { entity: Update<Entity> }) =>
            ({
                ...state,
                entities: entitiesAdapter.updateOne(entity, state.entities),
            })
    )
);

